import React from 'react';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import FAQAccordion from '@common/components/FAQAccordion';

import './FAQSection.scss';

const getFaqData = () => [
  {
    top: trans('home.tenant.FAQ-section.first-item.title'),
    content: trans('home.tenant.FAQ-section.first-item.content')
  },
  {
    top: trans('home.tenant.FAQ-section.second-item.title'),
    content: trans('home.tenant.FAQ-section.second-item.content')
  },
  {
    top: trans('home.tenant.FAQ-section.third-item.title'),
    content: trans('home.tenant.FAQ-section.third-item.content')
  },
  {
    top: trans('home.tenant.FAQ-section.fourth-item.title'),
    content: trans('home.tenant.FAQ-section.fourth-item.content')
  },
  {
    top: trans('home.tenant.FAQ-section.fifth-item.title'),
    content: trans('home.tenant.FAQ-section.fifth-item.content')
  },
  {
    top: trans('home.tenant.FAQ-section.sixth-item.title'),
    content: trans('home.tenant.FAQ-section.sixth-item.content')
  }
];

const FAQSection = () => {
  return (
    <section className="faq-section">
      <h2 className="faq-section__title">
        {trans('home.tenant.FAQ-section.title')}
      </h2>
      <div className="faq-section__accordion-wrapper">
        <FAQAccordion data={getFaqData()} theme={FAQAccordion.themes.tenant} />
      </div>
      <div className="faq-section__bottom">
        {`${trans('home.tenant.FAQ-section.footer.title')} `}
        <a
          href={getPagePath('help-center')}
          target="_blank"
          rel="noopener noreferrer"
        >
          {trans('home.tenant.FAQ-section.footer.link')}
        </a>
      </div>
    </section>
  );
};

export default FAQSection;
